import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import CloseButton from '../../../Button/CloseButton';
import s from './LiveNotificationCard.scss';
const LiveNotificationCard = ({ children, onClose, onMouseEnter, onMouseLeave, biData })=>/*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, children), /*#__PURE__*/ React.createElement(CloseButton, {
        className: s['close-btn'],
        onClick: onClose,
        biData: BiData(_object_spread({
            evid: 655
        }, biData))
    }));
LiveNotificationCard.displayName = 'LiveNotificationCard';
export default LiveNotificationCard;
